export const limitesVenda = [
  { uf: "AC", limite: 500 },
  { uf: "AL", limite: 500 },
  { uf: "AM", limite: 10000 },
  { uf: "AP", limite: 10000 },
  { uf: "BA", limite: 500 },
  { uf: "CE", limite: 10000 },
  { uf: "DF", limite: 10000 },
  { uf: "ES", limite: 10000 },
  { uf: "GO", limite: 10000 },
  { uf: "MA", limite: 10000 },
  { uf: "MG", limite: 10000 },
  { uf: "MS", limite: 10000 },
  { uf: "MT", limite: 1000 },
  { uf: "PA", limite: 10000 },
  { uf: "PB", limite: 500 },
  { uf: "PE", limite: 5000 },
  { uf: "PI", limite: 3000 },
  { uf: "RN", limite: 10000 },
  { uf: "RO", limite: 10000 },
  { uf: "RR", limite: 10000 },
  { uf: "RS", limite: 10000 },
  { uf: "SC", limite: 10000 },
  { uf: "SE", limite: 5000 },
  { uf: "SP", limite: 10000 },
  { uf: "TO", limite: 2000 },
];